// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"955":"78371b10","957":"78371b10","1768":"78371b10","5138":"78371b10","5221":"b242176b","5271":"78371b10","6076":"a403e210","9328":"815c65c7","9352":"78371b10"}[chunkId] + ".chunk.css";
};